import { retryReactLazy } from "./utils/retryReactLazy";

//* Retry React.lazy import
const retryReactLazyOptions = {
  retries: 5,
  delay: 1000,
  enablePageReload: true,
};

const TableBigComponent = retryReactLazy(
  () => import("./components/TableBigComponent"),
  "TableBigComponent",
  retryReactLazyOptions
);

const SingleTripReport = retryReactLazy(
  () => import("./components/reports/SingleTripReport"),
  "SingleTripReport",
  retryReactLazyOptions
);

const DeviationReport = retryReactLazy(
  () => import("./components/reports/DeviationReport"),
  "DeviationReport",
  retryReactLazyOptions
);

const ActiveBlocksAccordion = retryReactLazy(
  () => import("./components/views/ActiveBlocksAccordion"),
  "ActiveBlocksAccordion",
  retryReactLazyOptions
);

const SingleReportAVL = retryReactLazy(
  () => import("./components/reports/SingleReportAVL"),
  "SingleReportAVL",
  retryReactLazyOptions
);

const ScheduleForRoute = retryReactLazy(
  () => import("./components/timetables/ScheduleForRoute"),
  "ScheduleForRoute",
  retryReactLazyOptions
);

const Last24HoursReport = retryReactLazy(
  () => import("./components/reports/Last24HoursReport"),
  "Last24HoursReport",
  retryReactLazyOptions
);

const AllTripsReport = retryReactLazy(
  () => import("./components/reports/AllTripsReport"),
  "AllTripsReport",
  retryReactLazyOptions
);

const AllVehiclesAVLReport = retryReactLazy(
  () => import("./components/reports/AllVehiclesAVLReport"),
  "AllVehiclesAVLReport",
  retryReactLazyOptions
);

const DownloadAllVehiclesAVL = retryReactLazy(
  () => import("./components/reports/DownloadAllVehiclesAVL"),
  "DownloadAllVehiclesAVL",
  retryReactLazyOptions
);

const CompareApisData = retryReactLazy(
  () => import("./components/timetables/CompareApisData"),
  "CompareApisData",
  retryReactLazyOptions
);

const BrigadeScheduleReport = retryReactLazy(
  () => import("./components/timetables/BrigadeScheduleReport"),
  "BrigadeScheduleReport",
  retryReactLazyOptions
);

const SelectedBusView = retryReactLazy(
  () => import("./components/views/SelectedBusView"),
  "SelectedBusView",
  retryReactLazyOptions
);

const StopPunctualityReport = retryReactLazy(
  () => import("./components/reports/StopPunctualityReport"),
  "StopPunctualityReport",
  retryReactLazyOptions
);

const BusLocationByDate = retryReactLazy(
  () => import("./components/reports/BusLocationByDate"),
  "BusLocationByDate",
  retryReactLazyOptions
);

//* Stats charts
const PredictionAccuracyInterval = retryReactLazy(
  () => import("./components/stats/PredictionAccuracyInterval"),
  "PredictionAccuracyInterval",
  retryReactLazyOptions
);

const PredictionAccuracyScatter = retryReactLazy(
  () => import("./components/stats/PredictionAccuracyScatter"),
  "PredictionAccuracyScatter",
  retryReactLazyOptions
);

const PredictionAccuracyRange = retryReactLazy(
  () => import("./components/stats/PredictionAccuracyRange"),
  "PredictionAccuracyRange",
  retryReactLazyOptions
);

//* Alerts Service Manager
const ServiceAlertsManager = retryReactLazy(
  () => import("./components/alerts/ServiceAlertsManager"),
  "ServiceAlertsManager",
  retryReactLazyOptions
);

const AddNewAlert = retryReactLazy(() => import("./components/alerts/AddNewAlert"), "AddNewAlert", retryReactLazyOptions);
const AlertDetails = retryReactLazy(() => import("./components/alerts/AlertDetails"), "AlertDetails", retryReactLazyOptions);

//* Routes Info
const RoutesInfo = retryReactLazy(() => import("./components/views/RoutesInfo"), "RoutesInfo", retryReactLazyOptions);

//* Modify Trips
const ModifyTripStatus = retryReactLazy(
  () => import("./components/views/ModifyTripStatus"),
  "ModifyTripStatus",
  retryReactLazyOptions
);

//* Download AllStopsPunctualityReport
const AllStopsPunctualityReportDownLoad = retryReactLazy(
  () => import("./components/reports/AllStopsPunctualityReportDownLoad"),
  "AllStopsPunctualityReportDownLoad",
  retryReactLazyOptions
);

//* Schedule Adherence for all Routes Report
const ScheduleAdherenceAllRoutes = retryReactLazy(
  () => import("./components/swiftly/ScheduleAdherenceAllRoutes"),
  "ScheduleAdherenceAllRoutes",
  retryReactLazyOptions
);

//* AverageSpeeds
const AverageSpeeds = retryReactLazy(
  () => import("./components/swiftly/AverageSpeeds"),
  "AverageSpeeds",
  retryReactLazyOptions
);

//* DownloadDailyStopsAdherence
const DownloadDailyStopsAdherence = retryReactLazy(
  () => import("./components/reports/DownloadDailyStopsAdherence"),
  "DownloadDailyStopsAdherence",
  retryReactLazyOptions
);

//* Headway
const HeadwayPerformanceTable = retryReactLazy(
  () => import("./components/swiftly/HeadwayPerformanceTable"),
  "HeadwayPerformanceTable",
  retryReactLazyOptions
);

//* SynopticLiveLadderView
const SynopticLiveLadderView = retryReactLazy(
  () => import("./components/swiftly/SynopticLiveLadderView"),
  "SynopticLiveLadderView",
  retryReactLazyOptions
);

//* VehicleToBlockReport
const VehicleToBlockReport = retryReactLazy(
  () => import("./components/reports/VehicleToBlockReport"),
  "VehicleToBlockReport",
  retryReactLazyOptions
);

//* TableBigComponentV2Wrapper
const TableBigComponentV2Wrapper = retryReactLazy(
  () => import("./components/TableBigComponentV2Wrapper"),
  "TableBigComponentV2Wrapper",
  retryReactLazyOptions
);

//* Delete Vehicles Cache
const DeleteVehiclesCache = retryReactLazy(
  () => import("./components/views/DeleteVehiclesCache"),
  "DeleteVehiclesCache",
  retryReactLazyOptions
);

//* Completed Trips Report
const CompletedTripsReport = retryReactLazy(
  () => import("./components/reports/CompletedTripsReport"),
  "CompletedTripsReport",
  retryReactLazyOptions
);

//* BlockWithTripsPunctualityAndOccupancyReport
const BlockWithTripsPunctualityAndOccupancyReport = retryReactLazy(
  () => import("./components/reports2/BlockWithTripsPunctualityAndOccupancyReport"),
  "BlockWithTripsPunctualityAndOccupancyReport",
  retryReactLazyOptions
);

//* TripAveragePaxReport
const TripAveragePaxReport = retryReactLazy(
  () => import("./components/reports2/TripAveragePaxReport"),
  "TripAveragePaxReport",
  retryReactLazyOptions
);

//* DwellTimeReport
const DwellTimeReport = retryReactLazy(
  () => import("./components/reports2/DwellTimeReport"),
  "DwellTimeReport",
  retryReactLazyOptions
);

//* TripInfo
const TripInfo = retryReactLazy(() => import("./components/timetables/TripInfo"), "TripInfo", retryReactLazyOptions);

//* RouteTripsStopAdherence
const RouteTripsStopAdherence = retryReactLazy(
  () => import("./components/reports2/RouteTripsStopAdherence"),
  "RouteTripsStopAdherence",
  retryReactLazyOptions
);

const appLazyImports = {
  TableBigComponent,
  SingleTripReport,
  DeviationReport,
  ActiveBlocksAccordion,
  SingleReportAVL,
  ScheduleForRoute,
  Last24HoursReport,
  AllTripsReport,
  AllVehiclesAVLReport,
  DownloadAllVehiclesAVL,
  CompareApisData,
  BrigadeScheduleReport,
  SelectedBusView,
  PredictionAccuracyInterval,
  PredictionAccuracyScatter,
  PredictionAccuracyRange,
  ServiceAlertsManager,
  AddNewAlert,
  AlertDetails,
  StopPunctualityReport,
  RoutesInfo,
  ModifyTripStatus,
  BusLocationByDate,
  AllStopsPunctualityReportDownLoad,
  ScheduleAdherenceAllRoutes,
  AverageSpeeds,
  DownloadDailyStopsAdherence,
  HeadwayPerformanceTable,
  SynopticLiveLadderView,
  VehicleToBlockReport,
  TableBigComponentV2Wrapper,
  DeleteVehiclesCache,
  CompletedTripsReport,
  BlockWithTripsPunctualityAndOccupancyReport,
  TripAveragePaxReport,
  DwellTimeReport,
  TripInfo,
  RouteTripsStopAdherence,
};

export default appLazyImports;
